<template src="../../templates/selection/compare-products.html"></template>
<script>

import jquery from 'jquery';

import FormRadio from '@f/Radio';
import FormButton from '@f/Button';
import FormCheckbox from '@f/Check';
import Modal from '@c/Modal';
import Grid from '@c/Grid';

import ColumnImage from './Column/Image';
import ColumnTitle from './Column/Title';
import ColumnPrice from './Column/Price';
import ColumnStockAvailability from './Column/StockAvailability';
import ColumnDelimiter from './Column/Delimiter';
import ColumnPoints from './Column/Points';
import ColumnProperty from './Column/Property';
import ColumnDefault from './Column/Default';
import ColumnAnswerPoints from './Column/AnswerPoints';
import ColumnFeature from './Column/Feature';
import ColumnList from './Column/List';

import CompetitorPopup from '../Competitors/CompetitorPopup';

import '../../styles/compare-products.scss';

export default {
    name: 'CompareProducts',
    components: {
        FormButton,
        FormRadio,
        FormCheckbox,
        Modal,
        Grid,
        CompetitorPopup,

        ColumnImage,
        ColumnTitle,
        ColumnPrice,
        ColumnStockAvailability,
        ColumnDelimiter,
        ColumnPoints,
        ColumnProperty,
        ColumnDefault,
        ColumnAnswerPoints,
        ColumnFeature,
        ColumnList,
    },
    props: {
        modes: {
            type: Array,
            default: () => ['selection', 'features'],
        },
        products: {
            type: Object,
            default: () => ({}),
        },
        questions: {
            type: Array,
            default: () => ([]),
        },
        titles: {
            type: Object,
            default: () => ({}),
        },
        details: {
            type: Object,
            default: () => ({}),
        },
        displayCompareProductsPopup: {
            type: [Boolean, Number],
            default() {
                return false;
            }
        },
        calculateResult: {
            type: Object,
            default: () => ({}),
        },
        selectedCompetitorProducts: {
            type: Object,
            default() {
                return {};
            }
        },
        onAddCompetitorProductsToCompare: {
            type: Function,
            default() {
                return () => {};
            }
        },
        onUnselectProduct: {
            type: Function,
            default() {
                return () => {};
            }
        },
        fnFormatPrice: {
            type: Function,
            default() {
                return () => {};
            }
        },
    },
    emits: ['update:displayCompareProductsPopup'],
    data() {
        return {
            selectedFinancialProduct: null,
            potentialFinancialProduct: null,
            displayCompetitorPopup: false,
            productIdToShowCompetitors: null,
            selectedProductsForCompare: this.selectedCompetitorProducts,
            handlers: {
                deleteFromCompare: (productId, isCompetitor) => {
                    if (isCompetitor) {
                        Object.keys(this.selectedProductsForCompare).forEach(lbrProductId => {
                            this.selectedProductsForCompare[lbrProductId] = this.selectedProductsForCompare[lbrProductId]
                                .filter(competitorProductId => competitorProductId !== productId);
                        });

                        this.onAddCompetitorProductsToCompare(this.selectedProductsForCompare);
                    } else {
                        this.onUnselectProduct(productId);
                    }
                },
                showCompetitorPopup: (productId = null) => {
                    this.productIdToShowCompetitors = productId;
                    this.onDisplayCompetitorPopup();
                },
            },
            showCompetitorProducts: true,
            imagePreviewSrc: null,
        };
    },
    computed: {
        filteredProducts() {
            if (!Array.isArray(this.products) || !this.products.length) {
                return [];
            }

            if (!this.showCompetitorProducts) {
                return [...this.products].filter(p => !p.competitor);
            }

            return [...this.products];
        },
        requiredQuestions() {
            const result = [];

            if (this.questions && this.questions.length > 0) {
                this.questions.forEach(question => {
                    if (
                        question.required
                        && (
                            typeof question.answer === 'undefined'
                            || question.answer.length === 0
                        )
                    ) {
                        result.push(question);
                    }
                });
            }

            return result;
        },
        answerTooltips() {
            const result = {};
            if (this.questions && this.questions.length > 0) {
                this.questions.forEach(question => {
                    if (question.answers && question.answers.length > 0) {
                        question.answers.forEach(answer => {
                            result[answer.id] = answer.comment;
                        });
                    }
                });
            }
            return result;
        },
        feed() {

            const columns = [
                {
                    name: 'preview_url',
                    hidden: true,
                    component: 'ColumnImage',
                    toFooter: true,
                    additional: ['link', 'id', 'competitor'],
                },
                {
                    name: 'name',
                    hidden: true,
                    component: 'ColumnTitle',
                    toFooter: true,
                    additional: ['link', 'region'],
                },
                {
                    name: 'selected',
                    hidden: true,
                    component: 'ColumnPrice',
                    toFooter: true,
                    additional: ['competitor'],
                },
                {
                    name: 'stockAvailability',
                    hidden: true,
                    component: 'ColumnStockAvailability',
                    toFooter: true,
                    additional: ['competitor', 'id', 'hasCompetitorProducts'],
                },
            ];
            if (this.modes.includes('selection')) {
                columns.push({
                    name: 'points',
                    title: 'Сценарий клиента',
                    component: 'ColumnPoints',
                    toFooter: false,
                    class: 'delimiter'
                });
            }


            let result = [];
            if (this.filteredProducts) {

                const footerLines = [];

                const buildColumn = (name, data = {}, options = {}) => ({
                    name: name,
                    data: data,
                    component: (options.component) ? options?.component : null,
                    options,
                });

                const buildDelimiter = (title, productLength = 3, options = {}) => {
                    const line = [];
                    line.push(buildColumn(
                        title,
                        {
                            type: 'delimiter',
                        },
                        {
                            ...{
                                component: 'ColumnDelimiter',
                                colspan: productLength + 1,
                            },
                            ...options
                        }
                    ));
                    return line;
                };

                const filterData = (data, fields = []) => {
                    const filtredData = {};

                    fields.forEach(key => {
                        if (typeof data[key] !== 'undefined') {
                            filtredData[key] = data[key];
                        } else {
                            filtredData[key] = null;
                        }
                    });

                    return filtredData;
                };

                // Cписок товаров с превью
                columns.forEach(column => {
                    const line = [];
                    if (typeof column.hidden !== 'undefined' && column.hidden) {
                        line.push(buildColumn(' '));
                    } else {
                        line.push(buildColumn(
                            column.title ? column.title : column.name,
                            {},
                            {class: `title${column.class ? ` ${column.class}` : ''}`}
                        ));
                    }
                    // line.push(line[line.length - 1]);

                    this.filteredProducts.forEach(product => {
                        let additional = {};
                        if (column.additional) {
                            additional = filterData(product, column.additional);
                        }

                        const type = typeof product[column.name];

                        let productData = {};
                        if (type !== 'string') {
                            productData = product[column.name];
                        }

                        line.push(buildColumn(
                            product[column.name],
                            {
                                ...productData,
                                ...additional,
                            },
                            column
                        ));
                    });
                    result.push(line);
                    if (column.toFooter) {
                        footerLines.push(line);
                    }
                });

                // Список вопросов и ответов.
                if (this.modes.includes('selection')) {
                    if (this.requiredQuestions.length > 0) {
                        this.requiredQuestions.forEach(requiredQuestion => {
                            result.push(buildDelimiter(
                                `Не ответили на вопрос: "${requiredQuestion.description}"`,
                                this.filteredProducts.length,
                                {
                                    class: 'text-red mw-1 font-weight-normal'
                                }
                            ));
                        });
                    }

                    Object.keys(this.titles).forEach(key => {
                        const answerKeys = Object.keys(this.titles[key].answers);
                        if (answerKeys.length > 0) {
                            answerKeys.forEach(answerKey => {

                                const answer = this.titles[key].answers[answerKey];
                                const line = [];

                                line.push(buildColumn(
                                    answer.title,
                                    {},
                                    {
                                        class: 'title pt-2 pr-2',
                                        /* // Пример тултипа, который поддерживается полем по умолчанию
                                    tooltip: {
                                        id: `compare-answer-comment-${answer.id}`,
                                        comment: this.getAnswerTooltip(answer.id)
                                    }*/
                                    }
                                ));

                                /* убираем дублирование левого столбца
                            line.push(buildColumn(
                                answer.title,
                                {
                                    class: 'title mt-2 mr-2'
                                }
                            ));/**/

                                this.filteredProducts.forEach(product => {
                                    if (
                                        typeof this.details[product.id] !== 'undefined'
                                        && typeof this.details[product.id].questions[key] !== 'undefined'
                                        && this.details[product.id].questions[key].answers[answerKey]
                                    ) {
                                        line.push(
                                            buildColumn(
                                                this.details[product.id].questions[key].answers[answerKey].points,
                                                {},
                                                {component: 'ColumnAnswerPoints'}
                                            )
                                        );
                                    } else {
                                        line.push(buildColumn('-'));
                                    }
                                });
                                result.push(line);

                                const comment = this.getAnswerTooltip(answer.id);
                                if (comment && comment !== '') {
                                    result.push(buildDelimiter(
                                        comment,
                                        this.filteredProducts.length,
                                        {
                                            class: 'tooltip'
                                        }
                                    ));
                                }


                                // Подбор по ТТХ внутри ответа...
                                const propertiesKeys = Object.keys(answer.properties);
                                if (propertiesKeys.length > 0) {
                                    propertiesKeys.forEach(propertyKey => {
                                        const subLine = [];
                                        const propertyDetails = answer.properties[propertyKey];

                                        subLine.push(buildColumn(
                                            ` - ${propertyDetails.title}`,
                                            {},
                                            {class: 'ml-2'}
                                        ));
                                        // subLine.push(subLine[subLine.length - 1]);

                                        this.filteredProducts.forEach(product => {
                                            if (
                                                typeof this.details[product.id] !== 'undefined'
                                                && typeof this.details[product.id].questions[key] !== 'undefined'
                                                && this.details[product.id].questions[key].answers[answerKey]
                                                && this.details[product.id].questions[key].answers[answerKey].properties[propertyKey]
                                            ) {
                                                const dataItem = this.details[product.id].questions[key].answers[answerKey].properties[propertyKey];

                                                // component
                                                subLine.push(
                                                    buildColumn(
                                                        '',
                                                        {
                                                            title: `${dataItem.value}`,
                                                            points: dataItem.points,
                                                        },
                                                        {component: 'ColumnProperty'}
                                                    )
                                                );
                                            } else {
                                                subLine.push(buildColumn('-'));
                                            }
                                        });
                                        result.push(subLine);
                                    });
                                }
                            });
                        }
                    });
                }


                // Комплектации
                const hasOptions = this.filteredProducts.filter(product => product.options.length);
                if (hasOptions) {
                    result.push(buildDelimiter('Комплектации', this.filteredProducts.length));

                    const optionsLine = [];
                    optionsLine.push(buildColumn(''));
                    this.filteredProducts.forEach(product => {
                        let optionsNames = [];
                        if (product.options.length) {
                            optionsNames = product.options.map(option => option.metadata.title);
                        }

                        optionsLine.push(buildColumn(
                            '',
                            {
                                list: optionsNames,
                            },
                            {
                                component: 'ColumnList',
                            }
                        ));
                    });
                    result.push(optionsLine);
                }


                // ТТХ
                if (this.modes.includes('features')) {
                    result.push(buildDelimiter('Характеристики', this.filteredProducts.length));
                    const groupFeatures = features => {
                        const featuresGrouped = {};
                        if (features.values && features.values.length > 0) {
                            // eslint-disable-next-line no-return-assign
                            features.values.forEach(value => featuresGrouped[value.feature.id] = value);
                        }
                        if (features.ranges && features.ranges.length > 0) {
                            // eslint-disable-next-line no-return-assign
                            features.ranges.forEach(range => featuresGrouped[range.feature.id] = range);
                        }
                        return featuresGrouped;
                    };
                    if (this.features.length > 0) {
                        const linesWithEqualFeatures = [];
                        const linesWithDifferentFeatures = [];

                        this.features.forEach(feature => {

                            const line = [];

                            line.push(buildColumn(
                                feature.name,
                                {
                                    class: 'mt-2',
                                }
                            ));

                            let lastFeature = 'initialValue';
                            let isFeaturesDifferent = false;
                            this.filteredProducts.forEach(product => {
                                const productFeatures = groupFeatures(product.features);

                                let currentFeature = 'initialValue';
                                if (
                                    typeof productFeatures[feature.id] !== 'undefined'
                                    && parseInt(productFeatures[feature.id]?.disabled, 10) === 0
                                ) {
                                    currentFeature = {...productFeatures[feature.id]};
                                }

                                if (currentFeature === 'initialValue') {
                                    line.push(buildColumn('-'));
                                } else {
                                    line.push(
                                        buildColumn(
                                            feature.id,
                                            {...{type: feature.type}, ...productFeatures[feature.id]},
                                            {component: 'ColumnFeature'}
                                        )
                                    );
                                }

                                console.log('lastFeature', lastFeature);
                                console.log('currentFeature', currentFeature);
                                if (!isFeaturesDifferent) {
                                    if (lastFeature === 'initialValue' && currentFeature !== 'initialValue') {
                                        lastFeature = currentFeature;
                                    } else {
                                        const featureType = currentFeature.feature?.type || null;
                                        if (!!featureType) {
                                            if (featureType === 'Range') {
                                                isFeaturesDifferent = lastFeature.first_value !== currentFeature.first_value
                                                    || lastFeature.second_value !== currentFeature.second_value;
                                            } else {
                                                isFeaturesDifferent = lastFeature.value !== currentFeature.value;
                                            }
                                        } else {
                                            isFeaturesDifferent = true;
                                        }

                                        lastFeature = currentFeature;
                                    }
                                }
                            });

                            console.log('isDiff', isFeaturesDifferent);

                            if (isFeaturesDifferent) {
                                linesWithDifferentFeatures.push(line);
                            } else {
                                linesWithEqualFeatures.push(line);
                            }
                        });

                        console.log('diff', linesWithDifferentFeatures);
                        console.log('eq', linesWithEqualFeatures);
                        result = result.concat(linesWithDifferentFeatures, linesWithEqualFeatures);
                    }

                    // Напоминаем какие товары смотрим
                    if (footerLines.length > 0) {
                        result.push(buildDelimiter(' ', this.filteredProducts.length));
                        result = [...result, ...footerLines];
                    }
                }

            }

            return result;
        },
        features() {
            const features = {};//ranges values // feature
            if (this.filteredProducts && this.filteredProducts.length > 0) {
                this.filteredProducts.forEach(product => {
                    [...product.features.values, ...product.features.ranges].forEach(featureValue => {
                        if (
                            typeof features[featureValue.feature.id] === 'undefined'
                            && parseInt(featureValue.disabled, 10) === 0
                        ) {
                            features[featureValue.feature.id] = featureValue.feature;
                        }
                    });
                });
            }

            return Object.values(features);
        },
        competitorProductsForCompare() {
            const result = {};
            const product = this.filteredProducts.find(p => p.id === this.productIdToShowCompetitors);
            if (
                !product.competitor
                && typeof this.calculateResult.competitorProducts[product.id] !== 'undefined'
                && this.calculateResult.competitorProducts[product.id].length > 0
            ) {
                this.calculateResult.competitorProducts[product.id].forEach(competitorProduct => {
                    if (typeof result[`p-${competitorProduct.id}`] === 'undefined') {
                        result[`p-${competitorProduct.id}`] = competitorProduct;
                    }
                });
            }

            return Object.values(result);
        },
    },
    watch: {
        products: {
            handler() {
                if (!this.filteredProducts.length) {
                    this.updateDisplayCompareProductsPopup(false);
                }
                this.initJQueryMagic();
            }
        },
        feed: {
            immediate: true,
            handler() {
                this.initJQueryMagic();
            }
        },
        selectedCompetitorProducts: {
            handler() {
                this.selectedProductsForCompare = this.selectedCompetitorProducts;
            }
        },
    },
    methods: {
        updateDisplayCompareProductsPopup(display) {
            this.$emit('update:displayCompareProductsPopup', display);
        },
        getAnswerTooltip(answerId) {
            return typeof this.answerTooltips[answerId] !== 'undefined' && this.answerTooltips[answerId]
                ? this.answerTooltips[answerId]
                : null;
        },
        onDisplayCompetitorPopup() {
            this.displayCompetitorPopup = !this.displayCompetitorPopup;
        },
        initJQueryMagic() {

            // Добавил таймаут для задержки вычислений, чтоб срабатывало после применения CSS гарантированно
            setTimeout(() => {

                //sticky scrollbar
                jquery(function (jQ) {
                    const table = document.querySelector('.compare-products-container');
                    const container = table.querySelector('.fixed-scrollbar-container');
                    let mouseDown = false;
                    let initScrollLeft = 0;
                    let startXPosition = 0;

                    const mouseDownHandler = e => {
                        initScrollLeft = container.scrollLeft;
                        startXPosition = e.clientX;
                        mouseDown = true;
                    };

                    const mouseUpHandler = () => {
                        mouseDown = false;
                        // self.buttonDisplayPrevDisplayStatus = document.querySelector('.compare-products-container' + ' .fixed-scrollbar-container').scrollLeft > 0;
                    };

                    const mouseLeaveHandler = () => {
                        mouseDown = false;
                        // self.buttonDisplayPrevDisplayStatus = document.querySelector('.compare-products-container' + ' .fixed-scrollbar-container').scrollLeft > 0;
                    };

                    const mouseMoveHandler = e => {
                        if (mouseDown) {
                            clearInterval(this.scrollInterval);
                            container.scrollLeft = initScrollLeft + (startXPosition - e.clientX);
                        }
                    };

                    const touchStartHandler = e => {
                        initScrollLeft = container.scrollLeft;
                        startXPosition = e.touches[0].clientX;
                        mouseDown = true;
                    };

                    const touchEndHandler = () => {
                        mouseDown = false;
                        // self.buttonDisplayPrevDisplayStatus = document.querySelector('.compare-products-container' + ' .fixed-scrollbar-container').scrollLeft > 0;
                    };

                    const touchMoveHandler = e => {
                        if (mouseDown) {
                            clearInterval(this.scrollInterval);
                            container.scrollLeft = initScrollLeft + (startXPosition - e.touches[0].clientX);
                        }
                    };

                    table.removeEventListener('mousedown', mouseDownHandler);
                    table.removeEventListener('mouseup', mouseUpHandler);
                    table.removeEventListener('mouseleave', mouseLeaveHandler);
                    table.removeEventListener('mousemove', mouseMoveHandler);
                    table.removeEventListener('touchstart', touchStartHandler);
                    table.removeEventListener('touchend', touchEndHandler);
                    table.removeEventListener('touchmove', touchMoveHandler);
                    table.addEventListener('mousedown', mouseDownHandler);
                    table.addEventListener('mouseup', mouseUpHandler);
                    table.addEventListener('mouseleave', mouseLeaveHandler);
                    table.addEventListener('mousemove', mouseMoveHandler);
                    table.addEventListener('touchstart', touchStartHandler);
                    table.addEventListener('touchend', touchEndHandler);
                    table.addEventListener('touchmove', touchMoveHandler);
                });
            }, 200);

        },
    }
};
</script>

<style lang="scss" scoped>
.image-preview {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgba(128, 128, 128, 0.66);
    z-index: 999;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    cursor: zoom-out;

    img {
        object-fit: contain;
        max-width: 70%;
        max-height: 70%;
        margin-top: auto;
        margin-bottom: auto;
    }
}
</style>
